"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const React = require("react");
function ErrorMessage({ message }) {
    return (React.createElement(React.Fragment, null, !!message && (React.createElement("div", { className: "alert alert-danger mt-1 text-start form-alert-danger", role: "alert" }, message))));
}
exports.default = ErrorMessage;
